import React, { useEffect, useState } from "react";

import { MenuItem, SelectChangeEvent } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Status } from "../../../util/enums";
import ConfirmationModal from "../../Dialogs/ConfirmationModal";
import Select from "../../Form/Select";

type Rows = {
  id?: number;
  status?: string;
};

interface Props {
  open: boolean;
  rows: Rows[];
  isLoading: boolean;
  hasErrors?: boolean;
  closeModal: () => void;
  update?: (id?: number, status?: string) => void;
  submit?: (statusChoice: string) => void;
}

const ConfirmChangeStatus = ({
  open,
  rows,
  isLoading,
  hasErrors,
  closeModal,
  update,
  submit,
}: Props) => {
  const { t: translate } = useTranslation();

  const [changeStatusChoice, setChangeStatusChoice] = useState<string>("");

  const handleChangeStatusTo = (statusChoice: string) => {
    const statusOptionsList = {
      [Status.ACTIVE.toLowerCase()]: Status.ACTIVE,
      [Status.INACTIVE.toLowerCase()]: Status.INACTIVE,
      invert: "invert",
    };
    const status = statusOptionsList[statusChoice];

    rows.forEach((row) => {
      if (row.id && update) {
        if (status === "invert")
          update(row.id, row.status === Status.ACTIVE ? Status.INACTIVE : Status.ACTIVE);
        else update(row.id, status);
      }
    });
  };

  useEffect(() => {
    if (hasErrors !== undefined && !hasErrors) {
      closeModal();
      setChangeStatusChoice("");
    }
  }, [hasErrors]);

  return (
    <ConfirmationModal
      title={translate("changeStatuses")}
      open={open}
      loading={isLoading}
      closeModal={closeModal}
      submit={() => {
        if (submit) {
          submit(changeStatusChoice);
        } else {
          handleChangeStatusTo(changeStatusChoice);
        }
      }}
      saveDisabled={changeStatusChoice === ""}
    >
      <Select
        data-cy="changeStatusSelect"
        label={translate("changeAllSelectedStatusesTo")}
        name="changeStatuses"
        value={changeStatusChoice}
        onChange={(event: SelectChangeEvent<any>) => setChangeStatusChoice(event.target.value)}
        placeholder={translate("selectAnOption")}
      >
        <MenuItem data-cy="active" value="active">
          {translate("active")}
        </MenuItem>
        <MenuItem data-cy="inactive" value="inactive">
          {translate("inactive")}
        </MenuItem>
        <MenuItem data-cy="invert" value="invert">
          {translate("invertStatuses")}
        </MenuItem>
      </Select>
    </ConfirmationModal>
  );
};

export default ConfirmChangeStatus;
